const ITEMS = [
    "ENERGY",
    "TRANSMISSION",
    "INFRASTRUCTURE",
    "INVESTMENT",
    "SCALE",
    "DIGON",
    "ORBITO",
    "SADJA GROUP INDONESIA",
    "KHARISMA DAMAR SATYA",
];

export const Marquee = () => {
    const row = [...ITEMS, ...ITEMS];
    return (
        <div
            data-testid="editorial-marquee"
            className="relative overflow-hidden border-y border-[#4a4c42] bg-[#24251f] py-6 select-none"
            aria-hidden="true"
        >
            <div className="marquee-track flex w-max items-center gap-10 whitespace-nowrap">
                {row.map((item, i) => (
                    <span key={i} className="flex items-center gap-10">
                        <span className="font-display text-2xl sm:text-3xl font-extrabold tracking-[0.14em] uppercase text-white/12">
                            {item}
                        </span>
                        <span className="w-2 h-2 rotate-45 bg-[#f6c422]/50" />
                    </span>
                ))}
            </div>
        </div>
    );
};
